export const links = [
    {
        id: 15,
        name: 'DSA Login',
        url: "https://rm.kanchaneshver.com/",
    },
    {
        id: 16,
        name: 'DSA Associates Login',
        url: "https://rm.kanchaneshver.com/",
    },
       {
        id: 17,
        name: 'Customer Login',
        url: "https://customer.kanchaneshver.com/",
    },
    // {
    //     id: 1,
    //     name: 'Sales Login',
    //     url: "https://sales.kanchaneshver.com/",
    // },
    {
        id: 14,
        name: 'Swift Payout Track',
        url: "https://aic.kanchaneshver.com/",
    },
    {
        id: 2,
        name: 'Senior Login',
        url: "https://rm.kanchaneshver.com/",
    },
    {
        id: 11,
        name: 'Banker Registration',
        url: "https://api.kanchaneshver.com/api/CamNoteDetail/self-banker-register-redirect",
    },
    {
        id: 9,
        name: 'DSA Registration',
        url: "https://api.kanchaneshver.com/api/CamNoteDetail/self-DSA-register?mobileNumber=9329745925",
    },
    {
        id: 10,
        name: 'DSA Associates Registration',
        url: "https://api.kanchaneshver.com/api/CamNoteDetail/DSA-Associate-register?mobileNumber=9329745925",
    },
    // {
    //     id: 12,
    //     name: 'DSA Ops Registration',
    //     url: "https://api.kanchaneshver.com/api/CamNoteDetail/self-DSA-Opps-register",
    // },
    // {
    //     id: 13,
    //     name: 'DSA Associate Ops Registration',
    //     url: "https://api.kanchaneshver.com/api/CamNoteDetail/DSA-Associate-Opps-register",
    // },
    {
        id: 1,
        name: 'Banker Login',
        url: "https://vp.kanchaneshver.com/",
    },
]
